

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Caret from './Caret';
import Translatable from '../../../../../../components/Translatable';

import styles from '../styles.js';

class CaretWrapper extends Component {
    constructor() {
        super();
        this.state = {
            animating: false
        };
    }

    componentDidMount() {
        const { handleToggle } = this;
        handleToggle();
    }

    handleToggle = () => {
        const { classId, filterGroupCollectionIndex, handleExpand, handleExpanded } = this.props;
        if (classId === 1) {
            setTimeout(() => {
                this.setState({ animating: true });
                setTimeout(() => {
                    handleExpanded(filterGroupCollectionIndex, 2);
                }, 250);
            }, 50);
        } else if (classId === 3) {
            this.setState({ animating: true });
            setTimeout(() => {
                handleExpand(filterGroupCollectionIndex);
            }, 250);
        }
    }

    toggleCollapse = () => {
        const { classId, filterGroupCollectionIndex, handleExpand, handleExpanded } = this.props;
        if (classId === 0) {
            handleExpand(filterGroupCollectionIndex, 1);
        } else {
            handleExpanded(filterGroupCollectionIndex, 3);
        }
    }

    render() {
        const { toggleCollapse } = this;
        const { animating } = this.state;
        const {
            classId,
            isExpanded,
            title
        } = this.props;
        let className = 'icon_closed';
        if (classId === 1 && animating) {
            className = 'icon_opening';
        } else if (classId === 2) {
            className = 'icon_open';
        } else if (classId === 3) {
            if (animating) {
                className = 'icon_closing';
            } else {
                className = 'icon_open';
            }
        }
        return (
            <button
                type="button"
                className={css(styles.component_button)}
                aria-disabled="false"
                onClick={toggleCollapse}
            >
                <div className={css(styles.containerInline)}>
                    <div className={css(styles.containerInline)}>
                        <span
                            style={{
                                pointerEvents: 'none'
                            }}
                        >{
                                isExpanded ?
                                    <Translatable
                                        content={{
                                            transKey: 'search.close_title',
                                            count: 1,
                                            replacements: {
                                                title
                                            }
                                        }}
                                    /> :
                                    <Translatable
                                        content={{
                                            transKey: 'search.see_all'
                                        }}
                                    />
                            }</span>
                    </div>
                    <div className={css(styles.containerInline)}>
                        <div style={{ marginLeft: '8px' }}>
                            <Caret className={className} />
                        </div>
                    </div>
                </div>
            </button>
        );
    }
}

CaretWrapper.defaultProps = {
    classId: null
};

CaretWrapper.propTypes = {
    classId: PropTypes.number,
    filterGroupCollectionIndex: PropTypes.number.isRequired,
    handleExpand: PropTypes.func.isRequired,
    handleExpanded: PropTypes.func.isRequired,
    isExpanded: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
};

export default CaretWrapper;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/CaretWrapper/CaretWrapper.jsx